var map = {
	"./bank/bank.png": "abb5",
	"./bank/crypto.png": "b1e3",
	"./bank/ewallet.png": "8c66",
	"./banklogo/bank.png": "ceb3",
	"./banklogo/crypto.png": "4372",
	"./banklogo/ewallet.png": "143f",
	"./czalo.png": "2f24",
	"./dy/icon_channel.png": "17ca",
	"./dy/icon_contact.png": "7587",
	"./dy/icon_mail.png": "e643",
	"./dy/icon_name.png": "266d",
	"./dy/icon_phone.png": "d85a",
	"./dy/icon_pwd.png": "ca77",
	"./dy/icon_qq.png": "2192",
	"./dy/icon_wechat.png": "29e1",
	"./dy/joinus.png": "626d",
	"./dy/logo.png": "db18",
	"./dy/logowhitee.png": "2510",
	"./home/logo.png": "266c",
	"./home/logo_w_text.png": "9fba",
	"./home/messages.png": "a975",
	"./home/purchases.png": "70c7",
	"./home/shoppings.png": "1748",
	"./home/user.png": "7026",
	"./home/visits.png": "01be",
	"./ind/55-ace-logo.png": "efbf",
	"./ind/ind-bg.png": "2c5d",
	"./ind/ind-logo.png": "6040",
	"./ind/logo.png": "7c82",
	"./ind2/789logo.png": "9926",
	"./ind2/ind-bg.png": "7c04",
	"./ind2/logo.png": "d7ee",
	"./kaka/cus-bg-kaka.png": "7f7c",
	"./kaka/cus-service-kaka.png": "742a",
	"./kaka/dow-kaka.png": "d0b5",
	"./kaka/first-bg-kaka.png": "b240",
	"./kaka/logo-kaka-game.png": "89a6",
	"./kaka/top-kaka.png": "2003",
	"./kr/kr-logo.png": "5db4",
	"./lh/logo.png": "5876",
	"./login/cus-bg.png": "8f6f",
	"./login/cus-girl-vn.png": "beb3",
	"./login/cus-girl.png": "32b6",
	"./login/cus-guy.png": "c133",
	"./login/cus-service.png": "ae24",
	"./login/dow.png": "862f",
	"./login/mid.png": "d4e3",
	"./login/top.png": "2894",
	"./logo_tf88.png": "aed1",
	"./my/bg.png": "078f",
	"./my/logo-fb8.png": "7b71",
	"./pak/logowhitee.png": "2a9d",
	"./sigua.png": "7104",
	"./supp1.png": "962e",
	"./supp2.png": "83fe",
	"./supp3.png": "b65c",
	"./th/logo-jolly88.png": "e12b",
	"./xf/icon_channel.png": "886e",
	"./xf/icon_mail.png": "2208",
	"./xf/icon_name.png": "2280",
	"./xf/icon_phone.png": "4f66",
	"./xf/icon_pwd.png": "2ba9",
	"./xf/icon_qq.png": "cc21",
	"./xf/icon_wechat.png": "19aa",
	"./xf/logo.png": "979d",
	"./xf/logowhitee.png": "6cb7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";